const route = {
	name: 'recruitment',
	path: 'recruitment',
	component: () => import('@/modules/recruitment/pages/page-recruitment'),
	meta: {
		title: 'Reclutamiento',
	},
	props: true,
	redirect: '/recruitment/new-recruitment',
	children: [
		{
			name: 'new-recruitment',
			path: 'new-recruitment',
			component: () =>
				import('@/modules/recruitment/pages/new-recruitment'),
		},
		{
			name: 'config-process-recruitment',
			path: 'config-process-recruitment',
			component: () =>
				import('@/modules/recruitment/components/steps-recruitment/step-config-process-recruitment'),
		},
		{
			name: 'config-activities-recruitment',
			path: 'config-activities-recruitment',
			component: () =>
				import('@/modules/recruitment/components/steps-recruitment/step-config-activities-recruitment'),
		},
		{
			name: 'template-interview',
			path: 'template-interview',
			component: () =>
				import('@/modules/recruitment/components/steps-recruitment/step-config-template-interview'),
		},
		{
			name: 'list-process-recruitment',
			path: 'list-process-recruitment',
			component: () =>
				import('@/modules/recruitment/pages/page-list-process-recruitment'),
		},
		{
			name: 'list-applicants',
			path: 'list-applicants/:id?',
			component: () =>
				import('@/modules/recruitment/components/list-applicants'),
		},
		{
			name: 'conduct-interview',
			path: 'conduct-interview',
			component: () =>
				import('@/modules/recruitment/components/interview'),
		},
		{
			name: 'process-applicant-selection',
			path: 'process-applicant-selection',
			component: () =>
				import('@/modules/recruitment/components/import-applicants/import-applicant'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/modules/recruitment/router/index.js